import Column from '../../../../shared/components/atoms/Column';
import { Amount } from './Cost';
import React from 'react';
import { IPriceData } from '../../../../Quotes/types/store';
import { getAdditionalPrice } from 'Quotes/selectors';

export function RapidActivationCharge(props: { displayRapidActivationCharge: boolean; selectedPrice: IPriceData }) {
  const rapidActivationCharge = getAdditionalPrice(props.selectedPrice.additional_prices, 'Rapid Activation Price');

  return (
    <>
      {props.displayRapidActivationCharge && rapidActivationCharge && (
        <div className="row no-gutters mt-1">
          <Column defaultWidth={2}>
            <span className="sub-heading"></span>
          </Column>
          <Column defaultWidth={2}>
            <span>Rapid Activation</span>
          </Column>
          <Column defaultWidth={1}>
            <span className="mr-2">Install</span>
            <Amount amount={rapidActivationCharge?.install ?? 0} className="rapid-activation-charge" />
          </Column>
          <Column defaultWidth={1} offsetDefaultWidth={1}>
            <span className="mr-2">Annual</span>
            <Amount amount={rapidActivationCharge?.annual ?? 0} className="rapid-activation-charge" />
          </Column>
        </div>
      )}
    </>
  );
}
